<template>
  <div class="filters">
    <div class="header">FILTERS</div>
    <filter-table></filter-table>
  </div>
</template>

<script>
import FilterTable from './FilterTable'
export default {
  name: 'filters',
  components: { FilterTable },
  methods: {
    getFilters () {
      console.log('filter table GET')
    }
  },
  mounted () {
    let self = this
    self.$sdk.get('/admin/filters', {
      token: self.$store.state.session.sessionToken
    }, r => {
      console.log('FILTERS', r)
      if (r.error) {
        return
      }
      self.$store.commit('filters/setFilterTable', r.list)
    })
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/Filters/index.vue